<template>
  <tr>
    <td>
      <v-btn
        :disabled="!item.layerObject"
        class="justify-start"
        :to="{
          name: 'layers-item',
          params: { id: item.layerObject ? item.layerObject.id : '' },
        }"
        target="_blank"
        text
        block
      >
        {{ formatName(item.layerObject) }}
      </v-btn>
    </td>
    <td>
      {{ formatDate(item.createdAt) }}
    </td>
    <td>
      {{ syncStatus[item.status] || '---' }}
    </td>
    <!-- <td>
      <Progress :value="item.percent" />
    </td> -->
    <td>
      {{ formatType(item.type) }}
    </td>
    <td>
      <v-expansion-panels style="max-width: fit-content;">
        <v-expansion-panel :disabled="!item.errors.length">
          <v-expansion-panel-header>
            Кол-во ошибок: {{ item.errors.length }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p v-for="(error, index) in item.errors" :key="`${error}-${index}`" class="ma-0">
              {{ error }}
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </td>
    <td>
      <v-btn
        color="success"
        class="elevation-0 ml-2"
        title="Скачать данные синхронизации"
        :disabled="!item.hasFile"
        @click="downloadSyncData(item.id)"
      >
        <v-icon>get_app</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
// import Progress from '@/components/common/Progress.vue';
import moment from 'moment';
import { syncStatus } from '@/constants/sync';

export default {
  // components: {
  //   Progress,
  // },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      syncStatus,
    };
  },
  mounted() {
    if (this.percent !== '100') {
      this.$echo.channel(`.object-sync.${this.item.id}`)
        .listen('.LayerObjectSyncStatus', (data) => {
          console.log(data);
        });
    }
  },
  beforeDestroy() {
    this.$echo.leave(`.object-sync.${this.data.id}`);
  },
  methods: {
    formatName(layerObject) {
      if (layerObject && layerObject.name) return layerObject.name;
      return '---';
    },
    formatType(type) {
      switch (type) {
        case 'import':
          return 'Импорт';
        case 'export':
          return 'Экспорт';
        default:
          return '---';
      }
    },

    formatDate(createdAt) {
      if (createdAt) return moment(createdAt).format('DD-MM-YYYY HH:mm:ss');
      return '---';
    },
    downloadSyncData(id) {
      this.$emit('download', id);
    },
  },
};
</script>
